import React from "react";

import { ConfirmDialog } from "../../../components/SyDialog";

const PopupBlockedDialog = ({ busy = false, onRetry, onCancel }) => (
  <ConfirmDialog
    title="Your browser blocked the payment window"
    message="Allow pop-ups for this site, or press Continue and we will open Paystack again."
    confirmText="Continue to Paystack"
    cancelText="Not now"
    tone="brand"
    busy={busy}
    onConfirm={onRetry}
    onCancel={onCancel}
  />
);

export default PopupBlockedDialog;
